import React from 'react';
import SuccesImg from '../../images/success-quiz.png';
import UpsetImg from '../../images/upset.png';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const QuizModal = ({score, submitFunc }) => {
    const isPassed = score >= 60;
    const navigate = useNavigate()
    const{t} = useTranslation()

    return (
        <div className='quiz-modal'>
            <div className="quiz-modal-content">
                <h2 style={{ color: isPassed ? '' : 'red' }} className="quiz-messeg">{isPassed ? t("passedTrue") : t("passedFalse")}</h2>
                <p className="quiz-modal-score">
                    {t("quizScore")} {score}
                </p>
                <img className='success-img' src={isPassed ? SuccesImg : UpsetImg} alt={isPassed ? "Success" : "Upset"} />
                {isPassed ? (
                    ""
                ) : (
                    <p className="quiz-modal-reply">{t("quizP")}</p>
                )
                }
                {isPassed ? (
                    <button className="quiz-modal-btn scoreModal" onClick={submitFunc}>{t("continueBtn")}</button>
                ) : (
                    // <div className='quiz-modal-btns-wrapper'>
                        <button onClick={submitFunc} className="quiz-modal-btn">{t("back")}</button>
                    // </div>
                )}
            </div>
        </div>
    );
}

export default QuizModal;
